var map = {
	"./albert einstein.jpg": 86441,
	"./android.jpg": 69401,
	"./apple logo.jpg": 64939,
	"./chat gpt.jpg": 99107,
	"./fb.jpg": 66430,
	"./ms office.jpg": 53196,
	"./uc browser 1.jpg": 13255,
	"./whats app.jpg": 88432
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24120;